import AddressSearchBar from '@otovo/shared/components/InterestRegistration/AddressSearch/AddressSearchBar';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { handleInterestCreated } from '@otovo/shared/lib/handleInterestCreated/handleInterestCreated';
import { createQueryParamsFromMatchedPartner } from '@otovo/shared/lib/handleInterestCreated/partnerQueryParamHelpers';
import { Cloud$Interest } from '@otovo/shared/types/cloudApi';
import { Cloud$MainHardwareType } from '@otovo/shared/types/cloudEnums';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { useRouter } from 'next/router';

type Props = {
  mainHardwareType?: Cloud$MainHardwareType;
};

const AddressSearchBarV2 = ({ mainHardwareType }: Props) => {
  const config = useGlobalConfig();
  const { BU_CONFIG } = config;
  const { locale } = useRouter() as { locale: Otovo$Locale };

  const interestCreatedArgs = {
    locale: locale || BU_CONFIG.locale,
    redirectBaseUrl: BU_CONFIG.BREEZE_REDIRECT_BASE_URL,
    queryParams: createQueryParamsFromMatchedPartner(BU_CONFIG.matchedPartner),
  };
  return (
    <AddressSearchBar
      version="v2025"
      locale={locale}
      mainHardwareType={mainHardwareType}
      submissionMethod="javascript"
      onInterestCreated={(interest: Cloud$Interest) => {
        handleInterestCreated({
          interest,
          ...interestCreatedArgs,
        });
      }}
    />
  );
};
export default AddressSearchBarV2;
